import * as React from "react";
import FormikAutocompleteField from "../../formik/FormikAutocomplete";
import PropTypes from "prop-types";
import { HttpClientConfig } from "../../../utils/HttpClient";

export const BrandAutocomplete = (props) => {
  const lookupUrl = `${HttpClientConfig.baseURL}/Brand/Lookup`;
  const lookupByIdUrl = `${HttpClientConfig.baseURL}/Brand/LookupById`;

  const handleAddClick = (e) => {
    console.log(e);
  }

  return (
    <FormikAutocompleteField {...props} lookupUrl={lookupUrl} lookupByIdUrl={lookupByIdUrl} onAddButtonClick={handleAddClick} />
  );
};

BrandAutocomplete.propTypes = {
  fieldName: PropTypes.string,
  label: PropTypes.string,
  formik: PropTypes.any
}

export default BrandAutocomplete;
